__turbopack_context__.v({
  "profile-dropdown-item": "profile-dropdown-items-module-scss-module__VU86ZG__profile-dropdown-item",
  "profile-dropdown-item-button": "profile-dropdown-items-module-scss-module__VU86ZG__profile-dropdown-item-button",
  "profile-dropdown-item-button__icon": "profile-dropdown-items-module-scss-module__VU86ZG__profile-dropdown-item-button__icon",
  "profile-dropdown-item__icon": "profile-dropdown-items-module-scss-module__VU86ZG__profile-dropdown-item__icon",
  "profile-dropdown-item__with-divider": "profile-dropdown-items-module-scss-module__VU86ZG__profile-dropdown-item__with-divider",
});
